<i18n>
{
  "en": {
    "specialCategory": "Mark if a dish is special",
    "specialFrameCategory": "Add special frame to a dish",
    "visibleCategory": "Mark product as visible"
  },
  "es": {
    "specialCategory": "Marcar si un plato es especial",
    "specialFrameCategory": "Añadir marco especial a un plato",
    "visibleCategory": "Marcar producto como visible"
  }
}
</i18n>

<template>
  <dynameat-info-modal class="pa-3">
    <v-flex class="no-overflow pa-3 space-children">
      <v-sheet class="d-flex flex-row justify-space-between">
        <div class="">{{ $t('specialCategory') }}</div>
        <v-icon color="primary">$checkboxStarOn</v-icon>
      </v-sheet>
      <v-sheet class="d-flex flex-row justify-space-between">
        <div>{{ $t('visibleCategory') }}</div>
        <v-icon color="primary">mdi-eye</v-icon>
      </v-sheet>
    </v-flex>
  </dynameat-info-modal>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import DynameatInfoModal from '@dynameat/components/DynameatInfoModal';

@Component
@Components({ DynameatInfoModal })
export default class MenuEngineerInfoButton extends Vue {
  visible = true;
}
</script>

<style scoped lang="scss">
.v-input--selection-controls__input{
  margin: 0;
}
.no-overflow {
  overflow: hidden;
}

.relative {
  position: relative;
}

.pointer-absolute {
  position: absolute;
  top: 10px;
  left: 142px;
}

.space-children {
  > div {
    margin-bottom: 10px;
  }
}

.width-90 {
  width: 90%;
}
</style>
